import { ShieldCheck, BadgeCheck, Sparkles, MapPin } from "lucide-react";
import Reveal from "./Reveal";

const ITEMS = [
  { icon: ShieldCheck, title: "Försäkrat", desc: "Trygg och ansvarsförsäkrad tjänst" },
  { icon: BadgeCheck, title: "Se Klart Ut-garanti", desc: "Nöjd kund eller vi putsar om" },
  { icon: Sparkles, title: "Kostnadsfri offert", desc: "Tydligt pris utan förpliktelser" },
  { icon: MapPin, title: "Hela Skaraborg", desc: "Privatpersoner och företag" },
];

export const TrustStrip = () => (
  <section className="border-y border-slate-100 bg-brand-iceBg" data-testid="trust-strip">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
      {ITEMS.map((it, i) => (
        <Reveal key={it.title} delay={i * 0.08}>
          <div className="flex items-center gap-3.5" data-testid={`trust-item-${i}`}>
            <span className="h-11 w-11 rounded-full bg-white border border-slate-100 shadow-[0_2px_10px_rgba(7,22,44,0.04)] flex items-center justify-center shrink-0">
              <it.icon className="h-5 w-5 text-brand-blue" strokeWidth={1.75} />
            </span>
            <div>
              <p className="text-sm font-semibold text-brand-ink">{it.title}</p>
              <p className="text-xs text-slate-500 mt-0.5">{it.desc}</p>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

export default TrustStrip;
